/* ==========================================================================
   CAIXA FILOSOFAL - Video flutuante da pagina de produto

   Uma bolha no canto inferior esquerdo com o video rodando mudo, feito gif.
   No clique, um modal com o player de verdade.

   Este arquivo so e carregado quando o produto TEM video no metafield
   (ver snippets/video-flutuante.liquid). Produto sem video nao baixa nada.

   ---------------------------------------------------------------------------
   A REGRA QUE GOVERNA O ARQUIVO INTEIRO: NADA ANTES DA HORA

   A pagina de produto e onde a conversao acontece. Um video de enfeite nao
   pode disputar banda com a foto do produto nem atrasar o primeiro desenho.
   Entao:

     - a previa nao tem `src` no HTML; quem preenche e este JS, e so depois
       do evento `load` da pagina;
     - o player do modal nasce no clique e MORRE no fechamento. Um <video>
       parado no DOM com src continua segurando buffer;
     - com movimento reduzido ou economia de dados ligada, a previa nem
       carrega: fica no poster ate alguem clicar.
   ========================================================================== */

(function () {
  'use strict';

  var bolha = document.querySelector('[data-video-abrir]');
  var modal = document.querySelector('[data-video-modal]');
  if (!bolha || !modal) return;

  var previa = bolha.querySelector('.video-bolha__previa');
  var palco = modal.querySelector('[data-video-palco]');
  var ultimoFoco = null;

  /* ---------- quando NAO tocar sozinho ----------

     Duas situacoes, e as duas sao pedido explicito de quem esta navegando:

     1. prefers-reduced-motion. Movimento que comeca sozinho e o caso classico
        de gatilho vestibular. Um video em loop e movimento continuo.
     2. Economia de dados (Save-Data, ou conexao 2g/3g declarada). Quem ligou
        isso esta pagando por megabyte ou esta numa conexao ruim; baixar video
        de enfeite sem pedir e desrespeito.

     Nos dois casos a bolha continua ali, com o poster e o botao de play. O
     video carrega no clique, que e uma escolha. */
  function podeTocarSozinho() {
    try {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
    } catch (e) {}

    var con = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (con) {
      if (con.saveData) return false;
      if (/2g/.test(con.effectiveType || '')) return false;
    }
    return true;
  }

  /* ---------- a previa ---------- */

  function ligarPrevia() {
    if (!previa || previa.getAttribute('src')) return;
    var fonte = bolha.getAttribute('data-fonte');
    if (!fonte) return;

    previa.setAttribute('src', fonte);
    /* O play pode ser recusado (politica de autoplay do navegador, aba em
       segundo plano). Recusado, fica o poster — que e exatamente o estado de
       repouso previsto. Sem o catch, a promessa rejeitada vira erro no
       console de todo mundo. */
    var p = previa.play();
    if (p && p.catch) p.catch(function () {});
  }

  /* A bolha e `position: fixed`, entao ela esta sempre na tela e um
     IntersectionObserver nunca ajudaria: o que importa aqui e ESPERAR o resto
     da pagina. `load` ja passou? Liga na proxima folga. Ainda nao? Espera. */
  function agendarPrevia() {
    if (!podeTocarSozinho()) return;

    var quando = function () {
      if (window.requestIdleCallback) {
        window.requestIdleCallback(ligarPrevia, { timeout: 2000 });
      } else {
        window.setTimeout(ligarPrevia, 600);
      }
    };

    if (document.readyState === 'complete') quando();
    else window.addEventListener('load', quando, { once: true });
  }

  /* Fora da aba, pausa. Video em loop numa aba escondida gasta bateria e dado
     sem ninguem ver nada. */
  document.addEventListener('visibilitychange', function () {
    if (!previa || !previa.getAttribute('src')) return;
    if (document.hidden) {
      previa.pause();
    } else if (podeTocarSozinho()) {
      var p = previa.play();
      if (p && p.catch) p.catch(function () {});
    }
  });

  /* ---------- o modal ---------- */

  function abrir() {
    ultimoFoco = document.activeElement;

    /* O player nasce agora. `autoplay` junto de `controls`: quem clicou na
       bolha quis ver o video, entao ele comeca. Com som, que e a diferenca
       entre o modal e a previa. */
    var video = document.createElement('video');
    video.className = 'video-modal__player';
    video.setAttribute('controls', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('autoplay', '');
    video.setAttribute('preload', 'auto');
    video.src = palco.getAttribute('data-fonte');
    palco.appendChild(video);

    modal.hidden = false;
    requestAnimationFrame(function () {
      modal.classList.add('esta-aberto');
      var fechar = modal.querySelector('.video-modal__fechar');
      if (fechar) fechar.focus();
    });

    document.documentElement.classList.add('video-travado');

    /* A previa para enquanto o modal estiver aberto: dois decodificadores do
       mesmo arquivo rodando ao mesmo tempo e desperdicio puro. */
    if (previa) previa.pause();
  }

  var relogio = null;

  function fechar() {
    modal.classList.remove('esta-aberto');
    document.documentElement.classList.remove('video-travado');

    window.clearTimeout(relogio);
    relogio = window.setTimeout(function () {
      modal.hidden = true;

      /* Destruir e nao so pausar. Zerar o src antes de remover faz o navegador
         soltar a conexao e o buffer na hora; so remover do DOM deixa o
         download seguir em alguns navegadores. */
      var video = palco.querySelector('video');
      if (video) {
        video.pause();
        video.removeAttribute('src');
        video.load();
        video.remove();
      }

      if (previa && previa.getAttribute('src') && podeTocarSozinho()) {
        var p = previa.play();
        if (p && p.catch) p.catch(function () {});
      }
      if (ultimoFoco && ultimoFoco.focus) ultimoFoco.focus();
    }, 200);
  }

  /* Foco presa no modal enquanto ele estiver aberto. Sao poucos focaveis (o
     fechar e os controles nativos do video), mas sem isto o Tab sai para o
     rodape atras do veu. */
  function prenderFoco(evento) {
    if (evento.key !== 'Tab' || modal.hidden) return;
    var focaveis = modal.querySelectorAll(
      'a[href], button:not([disabled]), video, [tabindex]:not([tabindex="-1"])'
    );
    if (!focaveis.length) return;
    var primeiro = focaveis[0];
    var ultimo = focaveis[focaveis.length - 1];
    if (evento.shiftKey && document.activeElement === primeiro) {
      evento.preventDefault();
      ultimo.focus();
    } else if (!evento.shiftKey && document.activeElement === ultimo) {
      evento.preventDefault();
      primeiro.focus();
    }
  }

  /* ---------- ligacao ---------- */

  bolha.addEventListener('click', abrir);

  modal.addEventListener('click', function (evento) {
    if (evento.target.closest('[data-video-fechar]')) fechar();
  });

  document.addEventListener('keydown', function (evento) {
    if (evento.key === 'Escape' && !modal.hidden) fechar();
    prenderFoco(evento);
  });

  agendarPrevia();
})();
